import React, { useCallback } from 'react';

import { SnackbarState } from '@/modules/core/core.types';
import { useSnackbar } from '@/modules/core/hooks';
import { EditPaymentMethodModal as EditModal } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/EditPaymentMethod';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import useHighlightedPaymentMethodStore from '@/modules/user/components/ManageProfile/components/ReimbursementOptions/stores/useHighlightedPaymentMethod.store';
import useHighlightById from '@/utils/hooks/useHighlightById';

interface Props {
  onSetVisible: (value: boolean) => void;
  refetchPaymentMethods: () => void;
}

const EditPaymentMethodModal: React.FC<Props> = ({ onSetVisible, refetchPaymentMethods }) => {
  const { handleAddPermanentSnackbar } = useSnackbar();
  const editableMethod = useStore((state) => state.editableMethod);
  const { reset, setHighlightedPaymentMethodId } = useHighlightedPaymentMethodStore();
  const { setHighlightedById } = useHighlightById({
    onSetHighlightedId: setHighlightedPaymentMethodId,
    reset,
  });

  const handleClose = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  const handleEditSuccess = useCallback((editedPaymentMethodId?: string) => {
    refetchPaymentMethods();
    handleAddPermanentSnackbar({
      text: 'Payment method was updated successfully!',
      state: SnackbarState.positive,
      closeIcon: true,
      autoRemove: true,
    });
    if (editedPaymentMethodId) {
      setHighlightedById(editedPaymentMethodId);
    }
    setTimeout(() => handleClose());
  }, [refetchPaymentMethods, setHighlightedById, handleAddPermanentSnackbar, handleClose]);

  return (
    <EditModal
      onClose={handleClose}
      onBack={handleClose}
      onSuccess={handleEditSuccess}
      methodForEdit={editableMethod}
    />
  );
};

export default EditPaymentMethodModal;
